export const LOAD = 'ethstats/pageLatency/LOAD';
export const LOAD_SUCCESS = 'ethstats/pageLatency/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/pageLatency/LOAD_FAIL';
